import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/Link'

import s from './WordpressLink.module.css'

function WordpressLink({
                         className = '',
                         isExternalLink = false,
                         url = null,
                         label = null,
                         children = null,
                         link = null,
                         ...props
                       }) {
  if (isExternalLink)
    return (
      <a
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className={classNames(s.container, className)}
        dangerouslySetInnerHTML={{ __html: label }}
        {...props}
      >
        {children}
      </a>
    )

  const linkNode = link?.nodes?.[0] || {}

  return (
    <Link
      type={linkNode.__typename}
      href={linkNode.uri || linkNode.slug}
      className={classNames(s.container, className)}
      {...props}
    >
      {children || label}
    </Link>
  )
}

WordpressLink.propTypes = {
  url: PropTypes.string,
  isExternalLink: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  link: PropTypes.object,
}

export default WordpressLink
